import { refreshProposedAppointments } from "api/appointments";
import { useMutation, useQueryClient } from "react-query";
import { GET_PROPOSED_APPOINTMENTS } from "@constants/reactQueryKeys";
import { useGlobalToast } from "components/GlobalToastProvider";

const useRefreshAppointments = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation((payload) => refreshProposedAppointments(payload), {
    onError: () => {
      showToast({
        message: "Error refreshing proposed appointments",
        errorState: true,
      });
      onError();
    },
    onSuccess: (...args) => {
      queryClient.removeQueries([GET_PROPOSED_APPOINTMENTS]);
      if (otherOptions.onSuccess) {
        otherOptions.onSuccess(...args);
      }
    },
    ...otherOptions,
  });

  return {
    refreshAppointments: mutate,
    isRefreshAppointmentsLoading: isLoading,
  }
}

export default useRefreshAppointments;